<section class="card">

    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
            <div *ngFor="let cashflowDetails of cashflows; let i = index;" class="table-responsive" style="margin-bottom: 40px;">
                <!--  -->
                <h5><b><label> Option {{i + 1}} :</label></b></h5>
              <table frame="box" class="table table-hover compact cell-border nowrap stripe" id="cashFlowTable" style="cursor: pointer;">
                <caption></caption>
                <thead style="border-top-style: double;">
                  <tr>
                    <th id="cf{{i}}" style="min-width:200px !important">Cash Flows</th>
                    <th id="cpd{{i}}" style="min-width:200px !important">Coupon Payment Date</th>
                    <th id="nodcp{{i}}" style="min-width:200px !important">No. of Days in Coupon Period</th>
                    <th id="cpd{{i}}" *ngIf="selectedCashFlowType[i] == 'Coupon'" style="min-width:236px !important">Coupon Payout Date</th>
                    <th id="air{{i}}" style="min-width:217px !important">Amount (in Rupees)</th>
                  </tr>
                </thead>
                <tbody>
  
                  <tr *ngFor="let cashflow of cashflowCouponDetails[i]; let j = index;" style="line-height: 25px;">
                    <td *ngIf="selectedCashFlowType[i] == 'Coupon'" style="min-width:200px !important" tabindex="1">Coupon</td>
                    <td *ngIf="selectedCashFlowType[i] != 'Coupon'" style="min-width:200px !important" tabindex="1">Compunded Interest</td>
                    <td style="min-width:200px !important" tabindex="1">{{cashflow.CouponPaymentDate}}</td>
                    <td style="min-width:200px !important" tabindex="1">{{cashflow.NoOfDaysInCouponPeriod}}</td>
                    <td *ngIf="selectedCashFlowType[i] == 'Coupon'" style="min-width:200px !important" tabindex="1">{{cashflow.CouponPayoutDate}}</td>
                    <td style="min-width:200px !important" tabindex="1"> ₹ {{cashflow.AmountInRupees}}</td>
                  </tr>
  
                  <tr style="line-height: 25px;">
                    <th id="tcp{{i}}" *ngIf="selectedCashFlowType[i] == 'Coupon'" style="text-align-last: center;" colspan="4">Total Coupon Payments</th>
                    <th id="tci{{i}}" *ngIf="selectedCashFlowType[i] != 'Coupon'" style="text-align-last: center;" colspan="3">Total Compounded Interest</th>
                    <th id="tcpa{{i}}"> ₹ {{totalCouponPaymentAmount[i]}}</th>
                  </tr>
  
                  <tr style="line-height: 25px;">
                    <td *ngIf="selectedCashFlowType[i] == 'Coupon'" colspan="5"></td>
                    <td *ngIf="selectedCashFlowType[i] != 'Coupon'" colspan="4"></td>
                  </tr>
  
                  <tr style="line-height: 25px;">
                    <th id="cashflow{{i}}" style="min-width:200px !important">Cash Flows</th>
                    <th id="pdfp{{i}}" style="min-width:200px !important">Principal due for Payment</th>
                    <th id="nodfid{{i}}" style="min-width:200px !important">No. of Days from Issue Date</th>
                    <th id="ppd{{i}}" *ngIf="selectedCashFlowType[i] == 'Coupon'" style="min-width:236px !important">Principal Payout Date</th>
                    <th id="amountIr{{i}}" style="min-width:217px !important">Amount (in Rupees)</th>
                  </tr>
  
                  <tr style="line-height: 25px;">
                    <td style="min-width:200px !important" tabindex="1">Principal</td>
                    <td style="min-width:200px !important" tabindex="1">{{cashflowPrincipalDetails[i].PrincipalDueDateForPayment}}</td>
                    <td style="min-width:200px !important" tabindex="1">{{cashflowPrincipalDetails[i].NoOfDaysFromIssueDate}}</td>
                    <td *ngIf="selectedCashFlowType[i] == 'Coupon'" style="min-width:200px !important" tabindex="1">{{cashflowPrincipalDetails[i].PrincipalPayoutDate}}</td>
                    <td style="min-width:200px !important" tabindex="1"> ₹ {{cashflowPrincipalDetails[i].PrincipalAmount}}</td>
                  </tr>
  
                  <tr style="line-height: 25px; border-bottom-style: double;">
                      <th id="tpCoupon{{i}}" *ngIf="selectedCashFlowType[i] == 'Coupon'" style="text-align-last: center;" colspan="4">Total Payments (Principal + Coupon) (A+B)</th>
                      <th id="tpCompound{{i}}" *ngIf="selectedCashFlowType[i] != 'Coupon'" style="text-align-last: center;" colspan="3">Total Payments (Principal + Compounded Interest) (A+B)</th>
                      <th id="tpAmount{{i}}"> ₹ {{totalPaymentPrincipalPlusCoupon[i]}}</th>
                    </tr>
                </tbody>
              </table>
            </div>
        </div>
      </div>
    </div>
  
  </section>